module.exports = __webpack_public_path__ + "static/img/li9_2.48d4b7d2.png";